export default __webpack_public_path__ + "static/4-5b95941232474d94a362ec81c7366bfd.png";